import React, { useState, useRef } from 'react';
import { Box, Typography, ClickAwayListener } from '@mui/material';
import RangeSlider from './RangeSlider';
import { KeyboardArrowDown } from '@mui/icons-material';

const RangeSliderDropdown = ({ filter, value, setValue, setFromRange }) => {
    const [open, setOpen] = useState(false);
    const dropdownRef = useRef(null);

    const handleToggle = () => setOpen((prev) => !prev);
    const handleClose = () => setOpen(false);

    return (
        <Box sx={{ position: 'relative', display: 'inline-block', width: 400 }}>
            <Box
                onClick={handleToggle}
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    background: '#FFFFFF',
                    border: '1px solid #0000001A',
                    borderRadius: open ? '1px 1px 0 0' : 1,
                    boxShadow: '0px 2px 1px -1px #0000001A',
                    padding: '8px',
                    cursor: 'pointer',
                    '&:hover': {
                        borderColor: '#0000001A',
                    },
                }}
            >
                <div className='row items-center'>
                    Range:
                    <div className="root-text">
                        {Array.isArray(value) ? `${value[0]}-${value[1]}` : value}
                    </div>
                </div>

                <KeyboardArrowDown sx={{ color: 'var(--secondary-700)' }} />
            </Box>

            {/* Dropdown menu */}
            {open && (
                <ClickAwayListener onClickAway={handleClose}>
                    <Box
                        ref={dropdownRef}
                        sx={{
                            position: 'absolute',
                            top: '100%',
                            left: 0,
                            zIndex: 9999,
                            borderRadius: 0,
                            marginTop: 0,
                            background: '#fff',
                            border: '1px solid #0000001A',
                            boxShadow: '0px 4px 6px rgba(0,0,0,0.1)',
                            minWidth: '100%',
                            p: 2,
                        }}
                    >
                        <div className='flex flex-col gap-y-2'>
                            <RangeSlider
                                value={value}
                                onChange={(e, newValue) => {
                                    setValue(newValue);
                                    setFromRange(newValue.toString());
                                }}
                                min={Number(filter.minRange || 0)}
                                max={Number(filter.maxRange || 10)}
                                ranges={filter.ranges || [
                                    { start: 0, end: 2, color: '#00BC7D' },
                                    { start: 2, end: 4, color: '#00C950' },
                                    { start: 4, end: 6, color: '#F0B100' },
                                    { start: 6, end: 8, color: '#FF6900' },
                                    { start: 8, end: 10, color: '#FB2C36' },
                                ]}
                            />
                            <Typography variant='subtitle2' className="text-[#0000004D]">Adjust slider to select score range</Typography>
                        </div>

                    </Box>
                </ClickAwayListener>
            )}
        </Box>
    );
};

export default RangeSliderDropdown;
